import BaseService from "./BaseService";

export default class AuthService extends BaseService {
  controllerName = "auth";

  async GetByExternalId(salesforceExternalId: string, includeChildren: boolean = false): Promise<any> {
    const resp = await this.Get(`account/${salesforceExternalId}`, { includeChildren });
    return resp.data ? resp.data : resp;
  }
}